import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react'

import { cn } from '../utilitarios/cn'
import { classesControle } from './campo'

export interface PropriedadesEntrada extends InputHTMLAttributes<HTMLInputElement> {
  temErro?: boolean
  /** Ícone ou texto fixo à esquerda (lupa da busca, `R$`). */
  prefixo?: ReactNode
  sufixo?: ReactNode
}

export const Entrada = forwardRef<HTMLInputElement, PropriedadesEntrada>(function Entrada(
  { temErro, prefixo, sufixo, className, ...resto },
  ref,
) {
  const controle = (
    <input
      ref={ref}
      className={cn(
        classesControle(temErro),
        'h-10',
        prefixo && 'pl-9',
        sufixo && 'pr-9',
        className,
      )}
      {...resto}
    />
  )

  if (!prefixo && !sufixo) return controle

  return (
    <div className="relative">
      {prefixo ? (
        <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-conteudo-fraco">
          {prefixo}
        </span>
      ) : null}
      {controle}
      {sufixo ? (
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-conteudo-fraco">
          {sufixo}
        </span>
      ) : null}
    </div>
  )
})
